import React from 'react';
import PropTypes from "prop-types";

const ToggleSwitch = ({ id, name, checked, disabled, onChange, ...props }) => {
    return (
        <div className={"toggle-switch2"}>
            <input
                {...props}
                type="checkbox"
                name={name}
                className="toggle-switch2-checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            /> {id ? (
                <label className="toggle-switch2__label" tabIndex={disabled ? -1 : 1} htmlFor={id} >
                    <span
                        className={disabled ? "toggle-switch2__inner toggle-switch2-disabled" : "toggle-switch2__inner"}
                        tabIndex={-1}
                    />
                    <span className={disabled ? "toggle-switch2__switch toggle-switch2-disabled" : "toggle-switch2__switch"}
                        tabIndex={-1}
                    />
                </label>
            ) : null}
        </div>
    );
};

ToggleSwitch.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    disabled: PropTypes.bool
};

export default ToggleSwitch;
